// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Z0jb1","ticketText":"styles_ticketText__-sSeQ","loadingIndicator":"styles_loadingIndicator__E16wm"};